(() => {
  const STORAGE_KEY = 'jr_shopify_preview_params_v1';

  const keepKey = (key) =>
    key === '_fd' ||
    key === 'pb' ||
    key === 'locale' ||
    key === 'currency' ||
    key.startsWith('preview_') ||
    key.startsWith('shopify_') ||
    key.startsWith('__shopify') ||
    key === 'key';

  const isLocalhost =
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === 'localhost' ||
    window.location.hostname.endsWith('.localhost');

  const readStored = () => {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return {};
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) {
      return {};
    }
  };

  const persist = (data) => {
    try {
      if (!data || typeof data !== 'object') return;
      const keys = Object.keys(data);
      if (!keys.length) return;
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
      // ignore
    }
  };

  const collect = () => {
    const stored = readStored();
    const currentParams = {};
    try {
      const current = new URL(window.location.href);
      current.searchParams.forEach((value, key) => {
        if (!keepKey(key)) return;
        if (value == null || value === '') return;
        currentParams[key] = value;
      });
    } catch (e) {
      // ignore
    }

    const merged = { ...stored, ...currentParams };

    if (isLocalhost) {
      if (!merged._fd) merged._fd = '0';
      if (!merged.pb) merged.pb = '0';
    }

    persist(merged);
    return merged;
  };

  const appendToUrl = (inputUrl) => {
    if (!inputUrl) return inputUrl;
    try {
      const url = new URL(String(inputUrl), window.location.origin);
      const preview = collect();
      Object.entries(preview).forEach(([key, value]) => {
        if (value == null || value === '') return;
        url.searchParams.set(key, String(value));
      });
      return url.toString();
    } catch (e) {
      return inputUrl;
    }
  };

  window.jrGetShopifyPreviewParams = collect;
  window.jrAppendShopifyPreviewParamsToUrl = appendToUrl;

  // Eagerly capture on load so later scripts can rely on sessionStorage.
  collect();
})();
